export default __webpack_public_path__ + "static/media/GoldCup.5b1f8608.svg";